import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../../hooks/useVariantAction'
import { useHook } from '../../../lenteHooks'
import { CommandModalButton } from '../../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../../commandActions/types'
import { NewFundForm } from './NewFundForm'

export const NewFundCommand = (props: ActionButtonProps) => {
  const translate = useTranslate()

  const { tenantId, isinKey } = useHook('routing.general.useFundPricesParams')({
    isIsinKeyOptional: true, // unused by create, but needed by cancel
  })

  const actions = useHook('mutators.unitlink.useCreateNewFundActions')({
    tenantId,
    isinKey: isinKey ?? '',
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="unitLink.NewFundCommandData"
      title={translate('fund.actions.createFund')}
      commandDataForm={NewFundForm}
      submit={submit}
      {...props}
    />
  )
}
